var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtRoom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17.21,
    viewBox: "0 0 19 17.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "room",
    transform: "translate(0 -24.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M71.247,28.028V26.863a.907.907,0,0,1,.907-.907h2.9a.907.907,0,0,1,.907.907v1.164a.9.9,0,0,1-.106.417h.891a.9.9,0,0,1-.106-.417V26.863a.907.907,0,0,1,.907-.907h2.9a.907.907,0,0,1,.907.907v1.164a.9.9,0,0,1-.106.417H83.23V25.293a1.169,1.169,0,0,0-1.169-1.169H70.548a1.169,1.169,0,0,0-1.169,1.169v3.152h1.975A.9.9,0,0,1,71.247,28.028Z",
    transform: "translate(-66.804 0)",
    fill: "#ff8700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M20.023,155.132H6.172l-2.436,6.283H22.459Z",
    transform: "translate(-3.597 -126.146)",
    fill: "#ff8700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M0,336.62v2.012a1.252,1.252,0,0,0,1.253,1.253h16.5A1.252,1.252,0,0,0,19,338.632V336.62Z",
    transform: "translate(0 -300.899)",
    fill: "#ff8700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M64.754,442.217H67l.2-1.76H64.55Z",
    transform: "translate(-62.155 -400.883)",
    fill: "#ff8700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M376.111,442.217h2.246l.2-1.76h-2.655Z",
    transform: "translate(-361.956 -400.883)",
    fill: "#ff8700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtRoom);
export default __webpack_public_path__ + "static/media/bt-room.4ccd0a6d205c9a63fbdf038adc4d30bb.svg";
export { ForwardRef as ReactComponent };